import { useApplicationPageMutation } from "./aggregatedData";
export function useCreateSelfServeDeferralRequest() {
  var _useApplicationPageMu = useApplicationPageMutation(function (_ref) {
      var applicationId = _ref.applicationId,
        eslProgramId = _ref.eslProgramId,
        eslIntake = _ref.eslIntake,
        academicProgramId = _ref.academicProgramId,
        academicIntake = _ref.academicIntake,
        visaStatus = _ref.visaStatus,
        reasonForDeferral = _ref.reasonForDeferral,
        otherReasonDetail = _ref.otherReasonDetail;
      return {
        url: "/self_serve_requests",
        method: 'POST',
        body: {
          data: {
            type: 'self_serve_deferral_request',
            attributes: {
              requestType: 'deferral',
              reasonForDeferral: reasonForDeferral,
              internalApplicationId: applicationId,
              requestData: {
                eslProgramId: eslIntake ? eslProgramId : null,
                eslIntake: eslIntake,
                academicProgramId: academicProgramId,
                academicIntake: academicIntake,
                visaStatus: visaStatus,
                otherReasonDetail: otherReasonDetail
              }
            }
          }
        }
      };
    }),
    mutate = _useApplicationPageMu.mutate,
    isLoading = _useApplicationPageMu.isLoading,
    isSuccess = _useApplicationPageMu.isSuccess,
    reset = _useApplicationPageMu.reset;
  return {
    createSelfServeRequest: mutate,
    isCreatingSelfServeRequest: isLoading,
    createdSelfServeRequest: isSuccess,
    resetCreateSelfServeRequest: reset
  };
}
export function useCreateSelfServeTuitionDepositRefundRequest() {
  var _useApplicationPageMu2 = useApplicationPageMutation(function (_ref2) {
      var applicationId = _ref2.applicationId,
        requestReason = _ref2.requestReason,
        otherReasonDetail = _ref2.otherReasonDetail;
      return {
        url: "/self_serve_requests",
        method: 'POST',
        body: {
          data: {
            type: 'self_serve_tuition_deposit_refund_request',
            attributes: {
              requestType: 'tuition_deposit_refund',
              requestReason: requestReason,
              internalApplicationId: applicationId,
              requestData: {
                otherReasonDetail: otherReasonDetail
              }
            }
          }
        }
      };
    }),
    mutate = _useApplicationPageMu2.mutate,
    isLoading = _useApplicationPageMu2.isLoading,
    isSuccess = _useApplicationPageMu2.isSuccess,
    reset = _useApplicationPageMu2.reset;
  return {
    createSelfServeRequest: mutate,
    isCreatingSelfServeRequest: isLoading,
    createdSelfServeRequest: isSuccess,
    resetCreateSelfServeRequest: reset
  };
}